import { useSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import { FilterOptionSerializer } from "web/types/serializers";

type UseFilterResult = {
    options: FilterOptionSerializer[];
    label: string;
    min?: number;
    max?: number;
    minActiveValue?: number;
    maxActiveValue?: number;
};

export function useFilter(sectionId: string): UseFilterResult {
    const filter = useSelector((state: ReduxStoreState) =>
        state.filters.data?.filters.find((filter) => filter.id === sectionId)
    );

    if (!filter) {
        throw new Error(`No filter found for ${sectionId}`);
    }

    let min = filter?.min;
    let max = filter?.max;

    let minActiveValue = filter?.final_price_from;
    let maxActiveValue = filter?.final_price_to;

    if (minActiveValue === undefined) {
        minActiveValue = min;
    }
    if (maxActiveValue === undefined) {
        maxActiveValue = max;
    }

    return {
        options: filter?.options ?? [],
        label: filter?.label,
        min: filter?.min,
        max: filter?.max,
        minActiveValue: filter?.final_price_from,
        maxActiveValue: filter?.final_price_to,
    };
}
